<template>
    <a
      href="#"
      class="btn btn-cancel !inline-block text-center !mx-1"
      @click.prevent="(e) => emit('click', e)"
    >
      <DocumentMagnifyingGlassIcon class="h-5 w-5" />
    </a>
  </template>
  
  <script setup>
  import { DocumentMagnifyingGlassIcon } from '@heroicons/vue/24/solid';
  
  const emit = defineEmits(['click'])
  </script>